import $ from 'jquery';

// Shopping cart js YW
window.responsiveMenu = function (action) {
          if (action == 'show') {
            $('.abc-header-responsive-menu__backdrop').css({
              'pointer-events': 'initial',
            });
          }

          if (action == 'hide') {
            $('.abc-header-responsive-menu__backdrop').css({
              'pointer-events': 'none',
            });
          }

          $('#abc-header-responsive-menu').stop().animate({
            width: action,
          }, {
            duration: 500,
            specialEasing: {
              width: 'easeOutCubic',
            },
            start: function () {
              $('.abc-header-responsive-menu__backdrop').stop().animate({
                opacity: action,
              }, {
                duration: 500,
                specialEasing: {
                  opacity: 'easeOutCubic',
                },
              });
            },
          });
        }// end Shopping cart js YW
let responsiveMenu = window.responsiveMenu;
export {responsiveMenu};
